import { styled } from "@mui/material/styles";

// Breadcrumb styles - converted to plain objects for sx prop usage
export const breadcrumbStyles = {
  root: {
    marginBottom: 10,
  },
  breadcrumb: {
    color: "white",
    fontSize: "14px",
  },
  separator: {
    color: "white",
  },
  typography: {
    fontWeight: "inherit",
  },
};

export const sectionStyles = {
  marginBottom: 100,
  minHeight: "400px",
};

export const styledHeaderLinkSx = ({ theme, anchorEl }) => ({
  background: "none",
  border: "none",
  display: "flex",
  alignItems: "center",
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  height: "2.5em",
  color: anchorEl ? theme.palette.secondary.main : theme.palette.grey[600],
  textDecoration: "none",
  cursor: "pointer",
  fontSize: ".875rem",
  textTransform: "none",
  whiteSpace: "nowrap",
  "&:hover,&:focus": {
    textDecoration: "none",
    color: theme.palette.primary.dark,
  },
  "&:active": {
    color: theme.palette.secondary.main,
  },
  "& svg:nth-of-type(1)": {
    marginRight: "8px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    "& span": {
      display: "none",
    },
  },
});

// Header link styled component - supports dynamic anchorEl prop
export const StyledHeaderLink = styled("button", {
  shouldForwardProp: (prop) => prop !== "anchorEl",
})(styledHeaderLinkSx);

// Header menu styles - converted to plain object for sx prop usage
export const headerMenuStyles = {
  list: {
    "& li, & li div": {
      color: "secondary.main",
      minWidth: "35px",
      transition: "none",
    },
    "& li:hover": {
      backgroundColor: "secondary.main",
      color: "white",
      "& div, & svg": {
        color: "white",
      },
    },
  },
};
